class TabbedBlock {
  constructor(element) {
    element.querySelector('.tab').classList.add("selected");
    const links = element.querySelectorAll('.tabbed-block-nav li a');
    if (links) {
      links.forEach((element) => {
        element.addEventListener('click', (element) => {
          element.preventDefault();
          element.querySelector(".tab").classList.remove("selected");
          var s = element.dataset.tab;
          element.querySelector("#" + s).classList.add("selected");
        });
    });
    }
  }
}

const tabbedBlocks = document.querySelectorAll(".tabbed-block");
if (tabbedBlocks) {
  tabbedBlocks.forEach(function (element) {
    new TabbedBlock(element);
  });
}